import { jwtDecode } from "jwt-decode";
import { useMemo } from "react";
import { useAuthStore } from "stores/useAuthStore";
import { AuthToken } from "types/auth/AuthType";

export const useAuth = () => {
  const { accessToken, user, login, logout, setUser, updateToken } =
    useAuthStore();

  const token = useMemo<AuthToken | null>(() => {
    if (!accessToken) return null;

    try {
      return jwtDecode<AuthToken>(accessToken);
    } catch (err) {
      console.error("Failed to decode token", err);
      return null;
    }
  }, [accessToken]);

  return {
    isLoggedIn: !!accessToken,
    token,
    user,
    login,
    logout,
    setUser,
    updateToken,
  };
};
